import React, {useEffect} from "react";
import {GSButton, GSForm, GSSidePanelPage} from "golfstatus_react_components";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
import {useMatch, useNavigate} from "react-router-dom";

//import scss
import "./tournament-round-hole-assignment-settings.scss"
import {useNotificationBanner} from "../../../../hooks/notificationHooks";
import {
  clearRoundNotifications,
  getRound,
  selectCurrentRound,
  selectRoundNotifications
} from "../../../../reducers/roundSlice";
import {useDispatch, useSelector} from "react-redux";
import { useRoundHooks, getRoundLabel } from "../../../../hooks/round/roundHooks";
import { getRoundAssignedTeamCount } from "../../../../hooks/round/roundHoleAssignmentHooks";

//Name the component
const TournamentRoundHoleAssignmentSettings = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const match = useMatch("/:tournamentID/rounds/:roundID/hole-assignments/settings");
  const notifications = useSelector(selectRoundNotifications);

  // selectors
  const currentRound = useSelector(selectCurrentRound);
  //a round's own label stands on its own. without one it is named for its number
  //and the sub round its siblings make it, which they are needed to work out.
  const {allRounds} = useRoundHooks();
  const roundLabel = getRoundLabel(currentRound, allRounds);

  // effects
  useEffect(() => {
    dispatch(getRound(match.params.roundID));
  }, [dispatch, match?.params?.roundID]);

  useEffect(() => {
    return () => {
      dispatch(clearRoundNotifications());
    };
  }, [dispatch]);

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `${roundLabel} Hole Assignments Settings`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  //the round counts the teams on each of its courses, so there's no need to load
  //every assignment to know whether there are any to clear
  const hasAssignedTeams = () => {
    return currentRound?.id === match?.params?.roundID && getRoundAssignedTeamCount(currentRound) > 0;
  };

  const getSettingsFormSections = () => {
    let form = [
      {
        type: "vertical x-large-gap",
        title: "Clear Assignments",
        fields: [
          {
            description: "This will remove all current hole assignments for this round.",
            align: 'align-start',
            value: (
              <GSButton
                type={"transparent red"}
                title={"Clear Assignments"}
                isDisabled={!hasAssignedTeams()}
                onClick={() => navigate(`${match.pathname.replace("settings", "remove-all")}`)}
              />
            ),
          },
        ],
      },
    ];

    return form;
  }

  const getContent = () => {
    return (
      <GSForm
        formTitle={`${roundLabel} Hole Assignments`}
        formSections={getSettingsFormSections()}
      ></GSForm>
    );
  };

  const timeoutAction = () => {
    dispatch(clearRoundNotifications());
  };

  const [banner] = useNotificationBanner({notifications, timeoutAction})

  return (
    //name the component tag
    <tournament-round-hole-assignment-settings>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
      ></GSSidePanelPage>
    </tournament-round-hole-assignment-settings>
  );
};

//export the new name
export default TournamentRoundHoleAssignmentSettings;
